<template>
    <b-card class="card-accent-light" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-regular fa-calendar-range"></i> <strong> Attests </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <attests-base :callback="createPatientAttest" borderless />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import AttestsBase from './AttestsBase'

import { mapActions } from "vuex"

export default ComponentExtension.extend({
    name: "attests",
    components: {
        'attests-base': AttestsBase
    },
    methods: {
        ...mapActions('health', ['createPatientAttest']),
    }
})
</script>